// extracted by mini-css-extract-plugin
export default {"loader__container":"Loader_loader__container__dne6P","loader":"Loader_loader__+lRPl","spin":"Loader_spin__E4RJ0"};